import React, { Component } from "react";
import { Link } from "react-router-dom";

import config from "../../../../config";
import DEMO from "../../../../store/constant";
import Aux from "../../../../hoc/_Aux";
import Menuitems from "../../../../menu-items";

let menuObj = new Menuitems();
class Breadcrumb extends Component {
  state = {
    main: [],
    item: [],
  };

  componentDidMount() {
    let items = menuObj.menu();

    items &&
      items.map((item, index) => {
        if (item.type && item.type === "group") {
          this.getCollapse(item, index);
        }
        return false;
      });
  }

  componentWillReceiveProps = () => {
    let items = menuObj.menu();
    items &&
      items.map((item, index) => {
        if (item.type && item.type === "group") {
          this.getCollapse(item);
        }
        return false;
      });
  };

  getCollapse = (item) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type && collapse.type === "collapse") {
          this.getCollapse(collapse);
        } else if (collapse.type && collapse.type === "item") {
          if (document.location.pathname === config.basename + collapse.url) {
            if (document.location.pathname === "/ie/maestrodatapreview") {
              this.setState({ item: null, main: item });
            } else {
              this.setState({ item: collapse, main: item });
            }
          }
        }
        return false;
      });
    }
    return false;
  };

  render() {
    let main, item;
    let breadcrumb = "";
    let title = "Welcome";
    let loc = window.location.pathname.split("/");
    const menuitem = loc[3];
    var apps = [
      "containercloud",
      "boxview",
      "pennyanalytics",
      "financeotc",
      "commercial",
      "fmt",
      "intermodal",
      "gcaoce",
      "shipmentqna",
      "triton",
    ];
    let appLp =
      window.location.pathname
        .split("/")
        .slice(0, 4)
        .join("/") + "/";

    if (this.state.main && this.state.main.type === "collapse") {
      if (apps.indexOf(menuitem) !== -1) {
        main = (
          <li className="breadcrumb-item">
            <a href={appLp}>{this.state.main.title}</a>
          </li>
        );
      } else {
        main = (
          <li className="breadcrumb-item">
            <a href={DEMO.BLANK_LINK}>{this.state.main.title}</a>
          </li>
        );
      }
    }

    if (this.state.item && this.state.item.type === "item") {
      title = this.state.item.title;
      item = <li className="breadcrumb-item">{title}</li>;

      if (
        this.state.item.breadcrumbs !== false &&
        window.location.pathname !== "/ie/ieplatform"
      ) {
        breadcrumb = (
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="page-header-title">
                   {/*  <h5 className="m-b-10">{title}</h5> */}
                  </div>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/ie/ieplatform">
                        <i className="feather icon-home" />
                      </Link>
                    </li>
                    {main}
                    {item}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    document.title = title + " | Maestro";

    return <Aux>{breadcrumb}</Aux>;
  }
}

export default Breadcrumb;
